import coreUtils from "../../../assets/scripts/core-utils.js";
import jQuery from "jquery";

const $ = jQuery;

const videoSection = (($) => { // eslint-disable-line

  const me = {};

  me.init = () => {

    coreUtils.initVideo($('.video-section .js-play-video'));

    // no autoplay in creo - load video directly
    // $('.video-section .js-play-video').on('click', function() {

    // $(this).closest('.video-section').addClass('video-active');
    $('.video-section').addClass('video-active');

    // });

  };

  return me;

})(jQuery);

export default videoSection;
